const totalMilestones = [500, 1000, 2000, 3000, 5000];
const countMilestones = [50, 100, 200, 300, 400, 500, 600, 700, 800, 900, 1000];

class ProgressBar extends HTMLElement {
  constructor() {
    super();
    this.current = 0;
    this.total = 0;
    this.attachShadow({ mode: "open" });
  }

  style() {
    return `
      :host {
        width: 100%;
        font-family: var(--basic-font, "Arial");
      }

      h3 {
        text-align: center;
      }

      #bar {
        display: flex;
        flex-direction: row;
        width: 100%;
        align-content: center;
        justify-items: center;
        align-items: center;
      }

      .meter {
        height: 20px;
        background: var(--grey, #ecf0f1);
        border-radius: 5px;
        padding: 5px;
        display:grid;
        align-items:center;
        width: 100%;
      }

      span {
        font-weight:bold;
        font-size: clamp(10px, 4vw, 18px);
      }

      .current-fill {
        display: block;
        height: 100%;
        background: var(--donation-main-color, #1abc9c);
      }

      .total-value {
        display:grid;
        grid-template-columns: auto auto;
        grid-gap: 0 5px;
      }

      .total-value span {
        font-size: clamp(10px, 4vw, 18px);
      }
    `;
  }

  async connectedCallback() {
    this.title = this.getAttribute("title") || "";
    this.hideTotal = this.getAttribute("hideTotal") == "" || null;
    this.campaign = this.getAttribute("campaign") || "";
    // Possible values: total, count, count-recurring. Total is sum of donation amounts.
    this.aggregate = this.getAttribute("aggregate") || "total";
    this.offset = Number(this.getAttribute("offset")) || 0;

    const milestonesAttr = this.getAttribute("milestones");
    const milestonesJSON = JSON.parse(
      "[" + this.getAttribute("milestones") + "]"
    );
    const milestones = (() => {
      try {
        if (
          milestonesAttr !== null &&
          Array.isArray(milestonesJSON) &&
          milestonesJSON.length > 0 &&
          milestonesJSON.every((x) => !isNaN(x))
        ) {
          return milestonesJSON;
        }
      } catch {}
      return this.aggregate === "total" ? totalMilestones : countMilestones;
    })();

    let url = `https://nis2.nahtamatudloomad.ee/api/donation/${this.campaign}/total`;
    if (this.aggregate === "count") {
      url = `https://nis2.nahtamatudloomad.ee/api/donation/${this.campaign}/contributors`;
    }
    if (this.aggregate === "count-recurring") {
      url = `https://nis2.nahtamatudloomad.ee/api/donation/${this.campaign}/contributors/recurring`;
    }

    const res = await fetch(url);
    this.current = Math.round(Number(await res.text()) + this.offset);

    let milestone = milestones[0];
    for (let i = 0; i < milestones.length; ++i) {
      milestone = milestones[i];
      if (milestones[i] > this.current) {
        break;
      }
    }
    while (milestone <= this.current) {
      milestone += 1000;
    }
    this.total = milestone;
    this.shadowRoot.innerHTML = this.render();
  }

  render() {
    const percentage = (this.current / this.total) * 100;
    return `
      <style>${this.style()}</style>
      ${(this.title != "null" && `<h3>${this.title}</h3>`) || ""}
      <section id="bar">
        <div class="meter">
          <span class="current-fill" style="width:${percentage}%"></span>
        </div>
        ${
          (!this.hideTotal &&
            `<span style="margin-left: 0.5rem">${Number(
              this.current
            ).toLocaleString("et")}</span>
              <span style="color:var(--donation-main-color, #1abc9c); margin: 0 5px 0 5px;">/</span>
              <span>${Number(this.total).toLocaleString("et")}</span>
             `) ||
          ""
        }
      </section>
    `;
  }
}

customElements.define("progress-bar", ProgressBar);
